export const techStack = [
  {
    name: "Java",
  },
  {
    name: "Spring Boot",
  },
  {
    name: "MySQL",
  },
  {
    name: "PostgreSQL",
  },
  {
    name: "MongoDB",
  },
  {
    name: "Git",
  },
  {
    name: "Docker",
  },
  {
    name: "ReactJS",
  },
  {
    name: "JavaScript",
  },
  {
    name: "JUnit",
  },
];
